module.exports = __webpack_public_path__ + "img/Parking.27d4e700.svg";